"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.LeaflyAPI = {
    getLeaflyStatus: function (companyId, locationId) { return index_1.axios.get("/api/v1/company/" + companyId + "/leafly/location/" + locationId + "/status").then(function (response) {
        var leaflyStatus = response.data;
        return leaflyStatus;
    }); },
    syncLeaflyProduct: function (companyId, locationId, productId) { return index_1.axios.post("/api/v1/company/" + companyId + "/leafly/location/" + locationId + "/product/" + productId); },
    syncAllLeaflyProducts: function (companyId) { return index_1.axios.post("/api/v1/company/" + companyId + "/leafly/products"); },
    deleteLeaflyProduct: function (companyId, locationId, productId) { return index_1.axios.delete("/api/v1/company/" + companyId + "/leafly/location/" + locationId + "/product/" + productId); },
};
//# sourceMappingURL=LeaflyAPI.js.map